//offical doc please visit
//https://developer.mozilla.org/zh-CN/docs/Web/API/IndexedDB_API/Using_IndexedDB

let db = null;
let data = [];
const dbName = "Cesium_CHBIM";
//返回状态码
const success = 0;
const fail = -1;
const rollback = -2;

/**
 * 初始化数据库
 * dbObjectList:数据库对象名集合
 * 示例: let dbObjectList = [
        {
          name: "login",       //数据库对象名称
          key: "timestamp",    //数据库对象主键
          isAutoIncrement: false, //主键是否自增
          isCreateIndex: false,//是否开启索引,索引名称和主键名称一致
          isUnique: false,     //索引值是否唯一
        },
      ];
 * fn:回调函数,参数(状态码)
 */
export function init(dbObjectList, fn) {
  if (!window.indexedDB) {
    console.log("浏览器不支持IndexedDB.");
    return;
  }
  let request = window.indexedDB.open(dbName);
  if (request == null) {
    fn(fail);
    return;
  }
  request.onerror = function(event) {
    console.log("数据库错误: " + event.target.errorCode);
    fn(fail);
  };
  request.onsuccess = function(event) {
    db = request.result;
    fn(success);
  };
  // on db upgraded event
  request.onupgradeneeded = function(event) {
    // update db instance
    db = event.target.result;
    //创建数据库对象
    dbObjectList.forEach((item) => {
      let objectStore;
      if (item.isAutoIncrement) {
        objectStore = db.createObjectStore(item.name, {
          autoIncrement: true,
        });
      } else {
        objectStore = db.createObjectStore(item.name, {
          keyPath: item.key,
        });
      }

      //是否创建索引
      if (item.isCreateIndex) {
        //createIndex(indexName, keyPath, options)
        //unique: true / false 索引内容是否重复
        objectStore.createIndex(item.key, item.key, { unique: item.isUnique });
      }
    });
    fn(success);
  };
}
/**
 * 插入一条数据
 * dbObjName:数据库对象名
 * key:主键
 * value:值
 * fn:回调函数,参数(状态码)
 */
export function add(dbObjName, value, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail);
    return;
  }
  let request = db
    .transaction([dbObjName], "readwrite")
    .objectStore(dbObjName)
    .add(value);
  if (request == null) {
    fn(fail);
    return;
  }
  request.onsuccess = (event) => {
    console.log("数据写入成功.");
    fn(success);
  };
  request.onerror = function(event) {
    console.log("数据写入失败");
    fn(fail);
  };
  request.onabort = function(event) {
    console.log("事务回滚");
    fn(rollback);
  };
}

/**
 * 更新一条数据
 * dbObjName:数据库对象名
 * key:主键
 * value:值
 * fn:回调函数,参数(状态码)
 */
export function update(dbObjName, value, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail);
    return;
  }
  let request = db
    .transaction([dbObjName], "readwrite")
    .objectStore(dbObjName)
    .put(value);
  if (request == null) {
    fn(fail);
    return;
  }
  request.onsuccess = function(event) {
    console.log("数据更新成功");
    fn(success);
  };
  request.onerror = function(event) {
    console.log("数据更新失败");
    fn(fail);
  };
  request.onabort = function(event) {
    console.log("事务回滚");
    fn(rollback);
  };
}

/**
 * 读取一条数据
 * dbObjName:数据库对象名
 * key:主键
 * fn:回调函数,参数(状态码,数据)
 */
export function read(dbObjName, key, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail, null);
    return;
  }
  let request = db
    .transaction([dbObjName])
    .objectStore(dbObjName)
    .get(key);
  if (request == null) {
    fn(fail, null);
    return;
  }
  request.onerror = function(event) {
    console.log("读取失败");
    fn(fail, null);
  };
  request.onsuccess = function(event) {
    fn(success, request.result);
  };
}

/**
 * 根据索引(唯一)读取数据
 * dbObjName:数据库对象名
 * index:索引名
 * key:索引的值
 * fn:回调函数,参数(状态码,数据)
 */
export function readUniqueIndex(dbObjName, index, key, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail, null);
    return;
  }
  let request = db
    .transaction([dbObjName])
    .objectStore(dbObjName)
    .index(index)
    .get(key);

  request.onerror = function(event) {
    console.log("读取失败");
    fn(fail, null);
  };

  request.onsuccess = function(event) {
    fn(success, request.result);
  };
}

/**
 * 根据索引(非唯一)读取数据
 * 如果用readUniqueIndex读取只会返回第一条匹配的数据
 * dbObjName:数据库对象名
 * index:索引名
 * key:索引的值
 * fn:回调函数,参数(状态码,数据)
 */
export function readRepeatIndex(dbObjName, index, key, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail, null);
    return;
  }
  let request = db
    .transaction([dbObjName])
    .objectStore(dbObjName)
    .index(index)
    .openCursor(IDBKeyRange.only(key));

  request.onerror = function(event) {
    console.log("读取失败");
    fn(fail, null);
  };
  data = [];
  request.onsuccess = function(event) {
    if (request.result) {
      data.push(request.result);
    } else {
      fn(success, data);
    }
  };
}
/**
 * 读取所有数据
 * dbObjName:数据库对象名
 * fn:回调函数,参数(状态码,数据)
 */
export function readAll(dbObjName, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail, null);
    return;
  }
  let request = db
    .transaction([dbObjName])
    .objectStore(dbObjName)
    .getAll();
  if (request == null) {
    fn(fail, null);
    return;
  }
  request.onerror = function(event) {
    console.log("读取失败");
    fn(fail, null);
  };
  request.onsuccess = function(event) {
    fn(success, request.result);
  };
}
/**
 * 删除一条数据
 * dbObjName:数据库对象名
 * key:主键
 * fn:回调函数,参数(状态码)
 */
export function remove(dbObjName, key, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail);
    return;
  }
  let request = db
    .transaction([dbObjName], "readwrite")
    .objectStore(dbObjName)
    .delete(key);
  if (request == null) {
    fn(fail);
    return;
  }
  request.onsuccess = function(event) {
    console.log("数据删除成功");
    fn(success);
  };
}

/**
 * 删除所有数据
 * dbObjName:数据库对象名
 * key:主键
 * fn:回调函数,参数(状态码)
 */
export function removeAll(dbObjName, fn) {
  if (db == null) {
    console.log("浏览器不支持IndexedDB.");
    fn(fail);
    return;
  }
  let request = db
    .transaction([dbObjName], "readwrite")
    .objectStore(dbObjName)
    .clear();
  if (request == null) {
    fn(fail);
    return;
  }
  request.onsuccess = function(event) {
    console.log("数据清除成功");
    fn(success);
  };
}

//关闭删除数据库
export function destroy() {
  if (db != null) {
    db.close();
  }
  window.indexedDB.deleteDatabase(dbName);
}
